export interface TimelineSlot {
  readonly top: number;
  readonly height: number;
  readonly borderRadius: number;
}

interface ExpandedLaneSlots {
  readonly reviewPeriods: TimelineSlot;
  readonly exceptionalStatuses: TimelineSlot;
  readonly heats: TimelineSlot;
  readonly events: TimelineSlot;
  readonly loading: TimelineSlot;
  readonly segmentCoverage: TimelineSlot;
}

interface CollapsedLaneSlots {
  readonly reviewPeriods: TimelineSlot;
  readonly exceptionalStatuses: TimelineSlot;
  readonly loading: TimelineSlot;
}

const maxSlotExtent = (slots: readonly TimelineSlot[]): number =>
  Math.max(...slots.map((slot) => slot.top + slot.height));

export const EXPANDED_LANE: ExpandedLaneSlots = {
  reviewPeriods: { top: 0, height: 7, borderRadius: 0.5 },
  exceptionalStatuses: { top: 10, height: 7, borderRadius: 0 },
  heats: { top: 20, height: 7, borderRadius: 0.5 },
  events: { top: 30, height: 7, borderRadius: 0 },
  loading: { top: 40, height: 7, borderRadius: 0 },
  segmentCoverage: { top: 50, height: 7, borderRadius: 0 },
};

export const COLLAPSED_LANE: CollapsedLaneSlots = {
  reviewPeriods: { top: 0, height: 5, borderRadius: 0 },
  exceptionalStatuses: { top: 6, height: 5, borderRadius: 0 },
  loading: { top: 12, height: 5, borderRadius: 0 },
};

export const EXPANDED_LANE_HEIGHT = maxSlotExtent(Object.values(EXPANDED_LANE));

export const COLLAPSED_LANE_HEIGHT = maxSlotExtent(
  Object.values(COLLAPSED_LANE)
);

export const LANE_GAP = 6;

export const VIEWING_WINDOW_LABEL: TimelineSlot = {
  top: EXPANDED_LANE_HEIGHT + LANE_GAP,
  height: 24,
  borderRadius: 1,
};

export const HOUR_LABEL: TimelineSlot = {
  top: VIEWING_WINDOW_LABEL.top,
  height: VIEWING_WINDOW_LABEL.height,
  borderRadius: 0,
};

export const DAY_TIMELINE_HEIGHT =
  VIEWING_WINDOW_LABEL.top + VIEWING_WINDOW_LABEL.height;

export const laneHeight = (isExpanded: boolean): number =>
  isExpanded ? EXPANDED_LANE_HEIGHT : COLLAPSED_LANE_HEIGHT;

export const STACK_HOUR_HEADER_HEIGHT = 16;

export const STACK_FOOTER_HEIGHT = VIEWING_WINDOW_LABEL.height;

export const STACK_LABEL_GUTTER = 64;
